'use client'

import DiscordIcon from '@/components/icons/logos/discord'
import FacebookIcon from '@/components/icons/logos/facebook'
import RedditIcon from '@/components/icons/logos/reddit'
import {
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Globe } from 'lucide-react'

export default function JoinLinkServiceField({ form }) {
  const services = [
    {
      id: 'website',
      nicename: 'Website',
      icon: <Globe className="fill-shades-100!" />,
    },
    {
      id: 'discord-server',
      nicename: 'Discord Server',
      icon: <DiscordIcon />,
    },
    {
      id: 'facebook',
      nicename: 'Facebook',
      icon: <FacebookIcon />,
    },
    {
      id: 'reddit',
      nicename: 'Reddit',
      icon: <RedditIcon />,
    },
  ]
  return (
    <FormField
      control={form.control}
      name="joinLinkService"
      render={({ field }) => (
        <FormItem>
          <Select
            name="linkService"
            onValueChange={field.onChange}
            defaultValue={field.value}
            className="mb-8"
          >
            <FormLabel>Select Platform</FormLabel>
            <SelectTrigger className="border-neutral-blue-700! bg-neutral-blue-800! w-full">
              <SelectValue placeholder="Select service" />
            </SelectTrigger>
            <SelectContent className="bg-neutral-blue-800!">
              {services?.map((linkService) => (
                <SelectItem key={linkService.id} value={linkService.id}>
                  <div className="flex items-center gap-2 text-p-2 font-semibold">
                    <div className="[&>svg]:size-6! [&>svg]:fill-shades-0">
                      {linkService.icon}
                    </div>
                    {linkService.nicename}
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          <FormMessage />
        </FormItem>
      )}
    />
  )
}
